import * as types from './actionTypes';  
import deleteAllOrderApi from '../api/deleteAllOrderApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doDeleteAllOrder(request) {

  return {
    type: types.DO_DELETE_ALL_ORDER, 
    request
  };
}

export function doDeleteAllOrderRes(data) {  
  return {
    type: types.DO_DELETE_ALL_ORDER_RES, 
    data
  };
}

export function deleteAllOrder(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      deleteAllOrderApi.doDeleteAllOrder(request).then(data => {
        dispatch(doDeleteAllOrderRes(data));
        dispatch(doDeleteAllOrderRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}